import request from '@/plugins/request'

export function getUserList(key, pageindex, pagesize) {
    return request({
        url: '/v1/User/GetUserList',
        method: 'post',
        data: {
            key: key,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function userEdit(id, userName, userPhone, password, repassword, userRoleId) {
    return request({
        url: '/v1/User/UserEdit',
        method: 'post',
        data: {
            id: id,
            userName: userName,
            userPhone: userPhone,
            password: password,
            rePassword: repassword,
            userRoleId: userRoleId
        }
    })
}

export function userDel(id) {
    return request({
        url: '/v1/User/UserDel',
        method: 'post',
        data: {
            id: id
        }
    })
}

export function getUserRoleSelList() {
    return request({
        url: '/v1/User/GetUserRoleSelList',
        method: 'post',
    })
}